import { render, staticRenderFns } from "./shopAdd.vue?vue&type=template&id=c9bbb868&scoped=true"
import script from "./shopAdd.vue?vue&type=script&lang=js"
export * from "./shopAdd.vue?vue&type=script&lang=js"
import style0 from "./shopAdd.vue?vue&type=style&index=0&id=c9bbb868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bbb868",
  null
  
)

export default component.exports